/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Otubusin Ademuyiwa",
  title: "Hi all, I'm Ademuyiwa",
  subTitle: emoji(
    "a Full Stack Engineer and Solutions Architect who builds scalable, data-driven products from the ground up. I specialize in turning complex problems into clean, maintainable systems, and I'm always exploring tools and approaches that make software faster to ship and easier to own."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1OuH6Cf0zsHPKOsRtDyC-f7ynEg3swUA3/view?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/tay4real",
  linkedin: "https://www.linkedin.com/in/otubusinademuyiwa/",
  gmail: "ademuyiwaolutayo@gmail.com",
  // gitlab: "https://gitlab.com/",
  facebook: "https://web.facebook.com/otubusinademuyiwa/",
  medium: "https://medium.com/@tay4real",
  stackoverflow: "https://stackoverflow.com/users/15290005/otubusin-ademuyiwa",
  twitter: 'x.com/otubusinad',
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FULL STACK DEVELOPER / SOFTWARE ENGINEER",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    ),
    emoji(
      "⚡ Frontend Languages and Framenwork: HTML5, JavaScript, CSS, React JS, React Native"
    ),
    emoji(
      "⚡ Backend Languages and Framenwork: Java, PHP, Node JS, Express JS, MongoDB, Postgres"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
   
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Federal University of Technology, Akure",
      logo: require("./assets/images/futaLogo.jpeg"),
      subHeader: "Master of Technology in Computer Science",
      duration: "Jan 2015 - Dec 2019",
      desc: "Carried out the research of performance analysis of Principal Component Analysis and Linear Discriminant Analysis for Face Recognition Systems",
      descBullets: [
        "Machine Learning Algorithms",
        "Data Visualization",
        "Data Analysis",
        "Performance Analysis",
        "Principal Component Analysis",
        "Linear Discriminant Analysis",
        "Face Recognition Systems"
      ]
    },
    {
      schoolName: "Olabisi Onabanjo University",
      logo: require("./assets/images/oouLogo.jpeg"),
      subHeader: "Bachelor of Science in Computer Engineering",
      duration: "November 2003 - May 2008",
      desc:
        "Developed Arithmentic Logic Unit (ALU) and Data Processing Unit (DPU) for the Motorola 68000 processor",
      descBullets: ["Software Engineering", "ALU", "Operating Systems"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend Development", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend Development", //Insert stack or technology you have experience in
      progressPercentage: "99%"
    },
    {
      Stack: "Mobile Development",
      progressPercentage: "96%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Principal Programme Analyst",
      company: "State Information Technology Agency (SITA) — Ondo State Government",
      companylogo: require("./assets/images/sitaLogo.png"),
      date: "Jan 2014 – Present",
      desc:
        "Lead software development and delivery of digital services for Ondo State Government, including the state-wide digital identity system, civil servants data capture system, and signage permit application system.",
      descBullets: [
        "Architect and deliver full-stack web and mobile applications across the complete SDLC — from requirements and system design through to deployment and iterative improvement.",
"Drove Agile adoption across the software team: sprint planning, backlog management, retrospectives — improving delivery cadence and software quality.",
"Standardised REST API design across legacy government systems, improving interoperability for new services.",
"Led delivery of the Kaddi Igbe Ayo state-wide digital identity system — registering Ondo State residents and enabling access to healthcare, palliatives, and welfare services at scale.",
"Conduct root-cause analysis on production incidents, resolve performance bottlenecks, and document resolutions to prevent recurrence.",
"Translate complex technical analysis into clear recommendations for senior management and non-technical stakeholders.",
      ]
    },
 {
      role: "Mobile App Developer",
      company: "Pentspace — MedTech Startup (Part-time)",
      companylogo: require("./assets/images/pentspace.png"),
      date: "Oct 2021 – Present",
      desc:
        "Lead development of the cross-platform patient-facing mobile app for a health-tech platform connecting patients with nearby healthcare providers.",
      descBullets: [
        "Built the cross-platform patient-facing mobile app using React Native for a health-tech platform connecting patients with nearby healthcare providers.",
"Developed backend APIs with Node.js, Express.js and MongoDB; integrated Cloudinary for media; deployed on Heroku with Socket.IO real-time messaging."
      ]
    },
 {
      role: "Full Stack Developer",
      company: "Independent / Freelance Practice",
      companylogo: require("./assets/images/epicode.jfif"),
      date: "Sept 2020 – Sept 2021",
      desc:
        "Independent contractor providing full-stack development services for various clients.",
      descBullets: [
        "Design and deliver end-to-end web and mobile applications across industries — scoping, architecture, development, testing, and cloud deployment on AWS.",
"Build scalable RESTful APIs, implement OAuth/JWT authentication, and apply Python data tooling alongside core MERN-stack and React Native work."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: "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",
  githubUserName: "tay4real", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: true, // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME WEB APPLICATIONS I CREATED",
  projects: [
    {
      // image: require("./assets/images/memfile.png"),
      projectName: "MemFile",
      projectDesc: "MemFile is an electronic document file management system that manages all incoming and outgoing correspondence within a government parastatal, enabling file movements and easy access to stored documents within the file.",
      footerLink: [
        {
          name: "View Demo",
          url: "https://memfile.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // image: require("./assets/images/mindcare.png"),
      projectName: "MindCare",
      projectDesc: "Mindcare is an health awareness application that allows anyone to measure their mental health status and get relevant information for better well-being.",
      footerLink: [
        {
          name: "View Demo",
          url: "https://mindcare.netlify.app"
        }
      ]
    },
    {
      // image: require("./assets/images/csdc.png"),
      projectName: "Civil Servants Data Capture",
      projectDesc: "Civil Servants Data Capture is an online web application data management system that captures and stores Ondo state employees' data.",
      footerLink: [
        {
          name: "View Live",
          url: "https://sitaapps.org/csdcapp/"
        }
      ]
    },
    {
      // image: require("./assets/images/ossaa.png"),
      projectName: "Ondo State Signage and Advertisement Agency Website",
      projectDesc: "Provides information about Ondo State Signage and Advertisement Agency and automates application for Signage permit in the state.",
      footerLink: [
        {
          name: "",
          url: " "
        }
      ]
    },
    {
      // image: require("./assets/images/pentspace.png"),
      projectName: "Pentspace",
      projectDesc: "A social media medical app intended to connect those that need health care services to healthcare service providers.",
      footerLink: [
        {
          name: "View Demo",
          url: ""
        }
      ]
    },
    {
      // image: require("./assets/images/aes.png"),
      projectName: "Automated Exam System",
      projectDesc: "Automated Exam System is a PHP web application for conducting examination in secondary schools. it offers three roles - admin, examiner and student. ",
      footerLink: [
        {
          name: "View Demo",
          url: "http://automatedexam.herokuapp.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Build for SDG Challenge 2020",
      subtitle:
        "Worked with a team of software developers to initiate and develop MindCare application, one of the top 15 highest ranking applications out of 60 submitted in the Build for SDG Challenge.",
      image: require("./assets/images/sdgLogo.png"),
      footerLink: [
        {
          name: "Certification",
          url:
            "https://drive.google.com/file/d/1Jtl9eP_n89GK-608gj9aj7Hn-vVGaNBz/view?usp=sharing"
        },
        {
          name: "Top 15 Projects",
          url:
            "http://buildforsdgprojects.andela.com/"
        },
       
      ]
    },
   

    {
      title: "PWA Web App Developer",
      subtitle:  "Completed Google Africa Developer Training program for Mobile Web Development",
      image: require("./assets/images/googleDevLogo.png"),
      footerLink: [
        {name: "Certification", url: "https://drive.google.com/file/d/1vCJ-bTYMtXCa47-KpjV-dCN9ei3F4Ylw/view?usp=sharing"},
        
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "Some of the projects and blogs that I have written",

  blogs: [
    {
      url:
        "https://www.doityourselfdigitals.com/2022/05/5-keys-to-turn-your-talent-into.html",
      title: "5 Keys to Turn Your Talent into a Profitable Business",
      description:
        "Do you want earn money from what you know how to do best?"
    },
    {
      url: "https://www.doityourselfdigitals.com/2022/05/getting-things-done-in-10-simple-steps.html",
      title: "Getting things done in 10 simple steps",
      description:
        "However, a lot of people find it difficult to complete what they have started. Here are 10 simple ways of getting any task done."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    ""
  ),

  talks: [
    {
      title: "",
      subtitle: "",
      slides_url: "",
      event_url: ""
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    ""
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "(+234)80 6003 1582",
  email_address: "ademuyiwaolutayo@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "otubusin-ademuyiwa", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
